// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"_2D8RpXbm3_EoFOILIQXuUT","marketType":"_2-G9VQFrBVB-_0RQ9XQBEn","marketText":"_882FBzYHY6nbViHXP2SQ2","oddsButton":"_4_lAvMdmpRZIhsVJW-b4M"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/firstDown/css/markets.css
// module id = 119
// module chunks = 0